import { InputTag } from 'mixs/base/input_mixin';
export class RadioMultiple extends InputTag {
  public init() {
    super.init();
    this.watch();
  }
  public onChange(e){
    this.dispatch({value: e.target.value});
  }
}

riot.mixin('inputs.radio-multiple', RadioMultiple as riot.TagMixin)
